<template>
  <div class="wrapper">
    <notFound :errorCode="errorCode" v-if="badRequest" />
    <svg v-if="loading" class="loader loader-animation" width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="48" cy="48" r="47" stroke="#F1F5F9" stroke-width="2"/>
      <path d="M95 48C95 22.0426 73.9574 1 48 1" stroke="#8C9196" stroke-width="2" stroke-linecap="round"/>
    </svg>
    <div v-if="!badRequest" class="credit-request">
      <section class="info-column" :class="{ showMobileMenu: showMobileMenu }">
        <header class="header" id="toHead" @click="showMobileMenu = !showMobileMenu">
          <h2 class="fn-title-1 title">Заявка на кредит</h2>
          <div class="icon">
            <img src="@/assets/icons/arrow-bottom.svg" alt="icon">
          </div>
        </header>

        <ul class="target-info">
          <li class="item">
            <span class="title m-subhead-m">Клієнт</span>
            <p class="data m-body-m">{{ supplementRequest.name ? supplementRequest.name : 'Немає даних'}}</p>
          </li>
          <li class="item">
            <span v-if="type === 'flp'" class="title m-subhead-m">ІПН</span>
            <span v-if="type === 'jur'" class="title m-subhead-m">ЄДРПОУ</span>
            <p class="data m-body-m">{{ requestData.code ? requestData.code : 'Немає даних'}}</p>
          </li>
          <li class="item">
            <span class="title m-subhead-m">Основний вид діяльності</span>
            <p class="data m-body-m">
              {{ supplementRequest.kved[0] ? supplementRequest.kved[0] : 'Немає даних'}}
            </p>
          </li>
          <li class="item">
            <span class="title m-subhead-m">Вид кредиту</span>
            <p class="data m-body-m">{{ requestData.creditType ? requestData.creditType : 'Немає даних'}}</p>
          </li>
          <li class="item">
            <span class="title m-subhead-m">Сума кредиту</span>
            <p class="data m-body-m">{{ requestData.creditSum ? `${requestData.creditSum} грн` : 'Немає даних'}}</p>
          </li>
          <li class="item">
            <span class="title m-subhead-m">Строк кредиту</span>
            <p class="data m-body-m">
              {{ requestData.creditTerm ? `${requestData.creditTerm} місяців` : 'Немає даних'}}
            </p>
          </li>
        </ul>
      </section>

      <section class="main-column">
        <header class="header">
          <h2 v-if="currentStep.name !== 'FinalStep'" class="fn-title-1 title">{{currentStep.title}}</h2>

          <div v-if="currentStep.name !== 'FinalStep' && statusId !== 9" class="steps">
            <div class="arrow-wrapper">
              <span class="arrow" :class="{disable : disableBackBtn}" v-on:click="sendData(-1)">
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 1L1 7L7 13" stroke="#00050A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
              <span class="arrow" :class="{disable : currentStep.stepNumber > 4}" v-on:click="sendData(1)">
                <svg width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1L7 7L1 13" stroke="#00050A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </span>
            </div>
            <p class="step-number m-body-m">
              <span v-if="type === 'flp'">Крок {{count + 1}} / {{priorityFlpPerson.length}}</span>
              <span v-else-if="type === 'jur'">Крок {{count + 1}} / {{priorityJurPerson.length}}</span>
            </p>
          </div>
        </header>

        <div class="form supplement-request" v-if="currentStep.name === 'SupplementRequest'">
          <div class="input">
            <DefaultInput
              :label="type === 'flp' ? 'ПІБ' : 'Назва компанії'"
              name="supplementRequestName"
              v-validate="'required'"
              :error="errors.has('supplementRequestName')"
              :value="supplementRequest.name"
              v-model="supplementRequest.name"
              :disabled="supplementRequest.nameDisable"
              :placeholder="type === 'flp' ? 'ПІБ' : 'Назва компанії'"/>
            <span class="error m-footnote-m" v-if="errors.first('supplementRequestName')">{{type === 'flp' ? 'Введіть прізвище ім’я по батькові' : 'Введіть назву компанії'}}</span>
          </div>
          <div class="input">
            <AutocompleteSelect
              label="Основний вид діяльності"
              name="supplementRequestKved"
              inputmode="numeric"
              filter="typeKved"
              :error="errors.has('supplementRequestKved')"
              v-validate="{ required: true }"
              :value="supplementRequest.kved[0]"
              v-model="supplementRequest.kved[0]"
              :options="kvedOptions"
              :disabled="supplementRequest.kvedDisable"
            />
            <span class="error m-footnote-m" v-if="errors.first('supplementRequestKved')">{{ errors.first('supplementRequestKved') }}</span>
          </div>
          <div class="input">
            <DefaultInput
                v-validate="'required'"
                :error="errors.has('addressLegal')"
                name="addressLegal"
                label="Юридична адреса"
                placeholder="Вкажіть адресу реєстрації бізнесу (адреса з ЄДР)"
                :value="supplementRequest.address_legal"
                v-model="supplementRequest.address_legal"
            />
            <span class="error m-footnote-m" v-if="errors.first('addressLegal')">{{ errors.first('addressLegal') }}</span>
          </div>
        </div>

        <div class="form about-business" v-if="currentStep.name === 'AboutBusiness'">
          <div class="input">
            <DefaultTextArea
              name="AboutBusinessBusinessDescription"
              v-validate="'required'"
              :error="errors.has('AboutBusinessBusinessDescription')"
              value="AboutBusiness.business_description"
              v-model="AboutBusiness.business_description"
              label="Опис бізнесу"
              placeholder="Опишіть детальніше чим займаєтесь, які послуги надаєте, партнерські зв’язки, соціальна активність, тощо."
              rows="3"
            />
            <span class="error m-footnote-m" v-if="errors.first('AboutBusinessBusinessDescription')">{{ errors.first('AboutBusinessBusinessDescription') }}</span>
          </div>
          <div class="input">
            <DefaultTextArea
              name="AboutBusinessSuppliers"
              v-validate="'required'"
              :error="errors.has('AboutBusinessSuppliers')"
              :value="AboutBusiness.suppliers"
              v-model="AboutBusiness.suppliers"
              label="Постачальники"
              placeholder="Вкажіть назви основних постачальників"
            />
            <span class="error m-footnote-m" v-if="errors.first('AboutBusinessSuppliers')">{{ errors.first('AboutBusinessSuppliers') }}</span>
          </div>
          <div class="input">
            <DefaultTextArea
              name="AboutBusinessBuyers"
              v-validate="'required'"
              :error="errors.has('AboutBusinessBuyers')"
              :value="AboutBusiness.buyers"
              v-model="AboutBusiness.buyers"
              label="Покупці"
              placeholder="Вкажіть назви основних покупців"/>
            <span class="error m-footnote-m" v-if="errors.first('AboutBusinessBuyers')">{{ errors.first('AboutBusinessBuyers') }}</span>
          </div>

          <div class="target-credit">
            <span class="error m-footnote-m" v-if="errors.first('AboutBusinessPurposeLoan')">{{ errors.first('AboutBusinessPurposeLoan') }}</span>
            <h3 class="title m-body-b">Цільове призначення кредиту</h3>

            <div class="select-type">
              <DefaultRadio
                name="AboutBusinessPurposeLoan"
                v-validate="'required'"
                :radioBtn = 'AboutBusiness.purpose_loan'
                v-model="AboutBusiness.checkedID"
              />
            </div>
          </div>

          <div class="sales-channel">
            <span v-if="salesChannelsError" class="error m-footnote-m">Виберіть хоч один канал продажу</span>
            <h3 class="title m-body-b">Канали продажу та/або надання послуг</h3>

            <div class="wrapper">
              <div class="item">
                <p class="m-body-m title">Торгові точки</p>

                <label class="tumbler">
                  <input type="checkbox" v-model="AboutBusiness.sales_channels.offline_store.is_selected" v-on:change="clearFields(); validateSalesChannels()"/>
                  <span class="tumbler-wrapper"></span>
                  <i class="dot"></i>
                </label>

                <div class="toggle-wrapper" v-if="AboutBusiness.sales_channels.offline_store.is_selected">
                  <div class="sales-items">
                    <div class="item" v-for="(item, index) in AboutBusiness.sales_channels.offline_store.attr" :key="index">
                      <DefaultTextArea
                        :name="'AboutBusinessOfflineStore' + index"
                        v-validate="'required'"
                        :error="errors.has('AboutBusinessOfflineStore' + index)"
                        :value="AboutBusiness.sales_channels.offline_store.attr[index]"
                        v-model="AboutBusiness.sales_channels.offline_store.attr[index]"
                        label="Фактична адреса"
                        placeholder="Місто, вулиця, номер будинку (офіс)..."/>
                      <span class="clear" v-if="AboutBusiness.sales_channels.offline_store.attr.length > 1" v-on:click="AboutBusiness.sales_channels.offline_store.attr.splice(index, 1)">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 8L16 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M16 8L8 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </span>
                      <span class="error m-footnote-m" v-if="errors.first('AboutBusinessOfflineStore' + index)">Заповніть поле</span>
                    </div>
                  </div>

                  <button class="m-subhead-m additional-btn second-color large-btn-100 add-items"
                          v-on:click="AboutBusiness.sales_channels.offline_store.attr.push('')"
                  >
                    <svg class="icon-plus" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 12H16" stroke="#00050A" stroke-width="2" stroke-linecap="round"/>
                      <path d="M12 8L12 16" stroke="#00050A" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    Додати ще (якщо є)
                  </button>
                </div>
              </div>

              <div class="item">
                <p class="m-body-m title">Інтернет магазин</p>

                <label class="tumbler">
                  <input type="checkbox" v-model="AboutBusiness.sales_channels.online_store.is_selected" v-on:change="clearFields()"/>
                  <span class="tumbler-wrapper"></span>
                  <i class="dot"></i>
                </label>

                <div class="toggle-wrapper" v-if="AboutBusiness.sales_channels.online_store.is_selected">
                  <div class="sales-items">
                    <div class="item" v-for="(item, index) in AboutBusiness.sales_channels.online_store.attr" :key="index">
                      <DefaultTextArea
                        :name="'AboutBusinessOnlineStore' + index"
                        v-validate="'required'"
                        :error="errors.has('AboutBusinessOnlineStore' + index)"
                        :value="AboutBusiness.sales_channels.online_store.attr[index]"
                        v-model="AboutBusiness.sales_channels.online_store.attr[index]"
                        label="Адреса сайту"
                        placeholder="https://forexample.com/"/>
                      <span class="clear" v-if="AboutBusiness.sales_channels.online_store.attr.length > 1" v-on:click="AboutBusiness.sales_channels.online_store.attr.splice(index, 1)">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 8L16 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M16 8L8 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </span>
                      <span class="error m-footnote-m" v-if="errors.first('AboutBusinessOnlineStore' + index)">Заповніть поле</span>
                    </div>
                  </div>

                  <button class="m-subhead-m additional-btn second-color large-btn-100 add-items"
                          v-on:click="AboutBusiness.sales_channels.online_store.attr.push('')"
                  >
                    <svg class="icon-plus" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 12H16" stroke="#00050A" stroke-width="2" stroke-linecap="round"/>
                      <path d="M12 8L12 16" stroke="#00050A" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    Додати ще (якщо є)
                  </button>
                </div>
              </div>

              <div class="item">
                <p class="m-body-m title">Соціальні мережі</p>

                <label class="tumbler">
                  <input type="checkbox" v-model="AboutBusiness.sales_channels.social_networks.is_selected" v-on:change="clearFields()"/>
                  <span class="tumbler-wrapper"></span>
                  <i class="dot"></i>
                </label>

                <div class="toggle-wrapper" v-if="AboutBusiness.sales_channels.social_networks.is_selected">
                  <div class="sales-items">
                    <div class="item" v-for="(item, index) in AboutBusiness.sales_channels.social_networks.attr" :key="index">
                      <DefaultTextArea
                        :name="'AboutBusinessSocialNetworks' + index"
                        v-validate="'required'"
                        :error="errors.has('AboutBusinessSocialNetworks' + index)"
                        :value="AboutBusiness.sales_channels.social_networks.attr[index]"
                        v-model="AboutBusiness.sales_channels.social_networks.attr[index]"
                        label="Назва соц. мережі та і’мя акаунту ( або link )"
                        placeholder="Приклад: instagram, bankalliance"/>
                      <span class="clear" v-if="AboutBusiness.sales_channels.social_networks.attr.length > 1" v-on:click="AboutBusiness.sales_channels.social_networks.attr.splice(index, 1)">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M8 8L16 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                          <path d="M16 8L8 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </span>
                      <span class="error m-footnote-m" v-if="errors.first('AboutBusinessSocialNetworks' + index)">Заповніть поле</span>
                    </div>
                  </div>

                  <button class="m-subhead-m additional-btn second-color large-btn-100 add-items"
                          v-on:click="AboutBusiness.sales_channels.social_networks.attr.push('')"
                  >
                    <svg class="icon-plus" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 12H16" stroke="#00050A" stroke-width="2" stroke-linecap="round"/>
                      <path d="M12 8L12 16" stroke="#00050A" stroke-width="2" stroke-linecap="round"/>
                    </svg>
                    Додати ще (якщо є)
                  </button>
                </div>
              </div>

              <div class="item">
                <p class="m-body-m title">Інше</p>

                <label class="tumbler">
                  <input type="checkbox" v-model="AboutBusiness.sales_channels.other.is_selected" v-on:change="clearFields()"/>
                  <span class="tumbler-wrapper"></span>
                  <i class="dot"></i>
                </label>

                <div class="toggle-wrapper" v-if="AboutBusiness.sales_channels.other.is_selected">
                  <div class="sales-items">
                    <div class="item">
                      <DefaultTextArea
                        name="AboutBusinessOthers"
                        v-validate="'required'"
                        :error="errors.has('AboutBusinessOthers')"
                        :value="AboutBusiness.sales_channels.other.attr[0]"
                        v-model="AboutBusiness.sales_channels.other.attr[0]"
                        label="Додаткова інформація"
                        rows="2"
                        placeholder="Зовнішня реклама, телемаркетинг, лекції, публічні виступи тощо"/>
                      <span class="error m-footnote-m" v-if="errors.first('AboutBusinessOthers')">Заповніть поле</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form leaders" v-if="currentStep.name === 'Leaders'">
          <div class="leaders-form">
            <div class="input">
              <DefaultInput
                name="AboutLeaderName"
                v-validate="'required'"
                :error="errors.has('AboutLeaderName')"
                :value="leaders.leader.name"
                v-model="leaders.leader.name"
                label="ПІБ керівника"
                placeholder=""
              />
              <span class="error m-footnote-m" v-if="errors.first('AboutLeaderName')">Заповніть поле</span>
            </div>

            <div class="input">
              <DefaultInput
                name="AboutLeaderTerm"
                type="number"
                inputmode="numeric"
                v-validate="'required|numeric'"
                :error="errors.has('AboutLeaderTerm')"
                :value="leaders.leader.term"
                v-model.number="leaders.leader.term"
                label="Кількість місяців працює на поточній посаді"
                placeholder=""
              />
              <span class="error m-footnote-m" v-if="errors.first('AboutLeaderTerm')">Введіть кількість місяців (тільки ціле число)</span>
            </div>

            <div class="input">
              <DefaultInput
                name="AboutLeaderCode"
                type="number"
                inputmode="numeric"
                v-validate="'required|numeric|length:10'"
                :error="errors.has('AboutLeaderCode')"
                :value="leaders.leader.code"
                v-model="leaders.leader.code"
                label="ІПН керівника"
                placeholder=""/>
            </div>
            <span class="error m-footnote-m" v-if="errors.first('AboutLeaderCode')">Поле повинно містити 10 цифр</span>
          </div>

          <div class="founders">
            <h3 class="title m-body-b">Інформація про засновників</h3>
          </div>

          <div class="founders-form">
            <div class="inputs-wrapper">
              <div class="founder-item" v-for="(item, index) in leaders.founders" :key="index">
                <div class="input">
                  <DefaultInput
                    :name="'FoundersName' + index"
                    v-validate="'required'"
                    :error="errors.has('FoundersName' + index)"
                    :value="leaders.founders[index].name"
                    v-model="leaders.founders[index].name"
                    label="ПІБ або назва засновника"
                    placeholder=""/>
                  <span class="clear" v-if="leaders.founders.length > 1" v-on:click="leaders.founders.splice(index, 1)">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 8L16 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16 8L8 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                    </span>
                  <span class="error m-footnote-m" v-if="errors.first('FoundersName' + index)">Заповніть поле</span>
                </div>

                <div class="input">
                  <DefaultInput
                    type="number"
                    inputmode="numeric"
                    :name="'FoundersCode' + index"
                    v-validate="{ required: true, numeric: true, regex: /^[0-9]{8}$|^[0-9]{10}$/ }"
                    :error="errors.has('FoundersCode' + index)"
                    :value="leaders.founders[index].code"
                    v-model="leaders.founders[index].code"
                    label="ІПН або ЄДРПОУ засновника"
                    placeholder=""/>
                  <span class="error m-footnote-m" v-if="errors.first('FoundersCode' + index)">Поле повинно містити 10 цифр для ІПН або 8 цифр для ЄДРПОУ</span>
                </div>

                <div class="input">
                  <DefaultInput
                    type="number"
                    inputmode="numeric"
                    :name="'FoundersProperty' + index"
                    v-validate="'required|decimal|min_value:1|max_value:100'"
                    :error="errors.has('FoundersProperty' + index)"
                    :value="leaders.founders[index].property"
                    v-model.number="leaders.founders[index].property"
                    label="Частка в %"
                    placeholder=""/>
                  <span class="error m-footnote-m" v-if="errors.first('FoundersProperty' + index)">Поле повинно мати значення від 1 до 100</span>
                </div>
              </div>
            </div>

            <button class="m-subhead-m additional-btn second-color large-btn-100 add-items"
                    v-on:click="addNewFounder()"
            >
              <svg class="icon-plus" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 12H16" stroke="#00050A" stroke-width="2" stroke-linecap="round"/>
                <path d="M12 8L12 16" stroke="#00050A" stroke-width="2" stroke-linecap="round"/>
              </svg>

              Додати ще (якщо є)
            </button>
          </div>

          <div class="founderApprove" v-on:click="toggleFounderApprove">

            <div class="default-checkbox">
              <input type="checkbox" id="founderAprove" name="check" v-model="founderApprove"/>
              <label for="founderApprove"></label>
            </div>

            <p>
              Підтверджую, що отримав згоду керівників та засновників на доступ АТ "БАНК АЛЬЯНС" до  їх кредитних історій через будь-яке бюро кредитних історій, а також дозвіл на обробку  їх персональних даних
            </p>
          </div>

        </div>

        <div v-if="currentStep.name === 'Finance'" class="form finance">
          <h3 class="m-body-b">Періодичність подання фінансової звітності</h3>

          <div class="select-period">
            <DefaultRadio
              v-bind:radioBtn = 'finance.financialReporting'
              v-model="finance.checkFinancialReporting"
            />
          </div>

          <div class="qved">
            <div class="qved-2000-1">
              <h3 class="title m-body-b">Розшифровка рядка 2000 Ф1</h3>
              <h4 class="subtitle m-body-m">Торгова виручка за КВЕДами</h4>

              <div class="items-wrapper">
                <div class="item-row" v-for="(item, index) in finance.kveds" :key="index">
                  <div class="input">
                    <AutocompleteSelect
                      :name="'financeKved' + index"
                      v-validate="{ required: true }"
                      :error="errors.has('financeKved' + index)"
                      label="КВЕД"
                      filter="typeKved"
                      inputmode="numeric"
                      :options="kvedOptions"
                      :value="finance.kveds[index].kved"
                      v-model="finance.kveds[index].kved"/>
                    <span class="error m-footnote-m" v-if="errors.first('financeKved' + index)">Заповніть поле</span>
                  </div>
                  <div class="input">
                    <DefaultInput
                      type="number"
                      inputmode="numeric"
                      :name="'financeKvedSum' + index"
                      v-validate="{ required: true, regex: /^([.,0-9]+)$/ }"
                      :error="errors.has('financeKvedSum' + index)"
                      :value="finance.kveds[index].summ"
                      v-model.number="finance.kveds[index].summ"
                      label="Сума, тис. грн"
                      placeholder=""/>
                    <span class="error m-footnote-m" v-if="errors.first('financeKvedSum' + index)">Введіть суму в тисячах гривень</span>
                  </div>
                  <span class="clear" v-if="finance.kveds.length > 1" v-on:click="finance.kveds.splice(index, 1)">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 8L16 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M16 8L8 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </span>
                </div>
              </div>

              <button
                v-on:click="addNewKved()"
                class="m-subhead-m additional-btn second-color large-btn-100 add-items"
              >
                <svg class="icon-plus" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M8 12H16" stroke="#00050A" stroke-width="2" stroke-linecap="round"/>
                  <path d="M12 8L12 16" stroke="#00050A" stroke-width="2" stroke-linecap="round"/>
                </svg>

                Додати ще (якщо є)
              </button>
            </div>
          </div>
        </div>

        <div v-if="currentStep.name === 'UploadDocument'" class="form upload-documents">
          <div class="recommendation">
            <span class="icon">
              <img src="@/assets/credit-request/info.svg" alt="info">
            </span>
            <span class="text m-body-m">
              Рекомендовані формати: jpg, png, pdf, doc, xls.
              <br>
              Максимальний розмір одного файлу до 25 мб
            </span>
          </div>

          <div class="upload-items">
            <div class="item declaration">
              <span v-if="declarationFilesError" class="error m-footnote-m">Завантажте мінімум один документ</span>
              <h3 v-if="type === 'flp'" class="title m-body-b">Декларація про доходи за останній звітній період (не меньш ніж за півроку)</h3>
              <h3 v-if="type === 'jur'" class="title m-body-b">Фінансова звітність за останній звітний рік</h3>
              <h4 class="subtitle m-body-m">З відміткою про прийняття від ДФС</h4>

              <div class="files">
                <div class="file-item" v-for="(item) in declarationFiles" :key="item.fileName">
                  <img v-if="item.type === 'application/msword'" class="file-icon" src="@/assets/credit-request/example-doc.svg" alt="doc">
                  <img v-else-if="item.type === 'image/jpeg'" class="file-icon" src="@/assets/credit-request/example-jpg.svg" alt="jpg">
                  <img v-else-if="item.type === 'application/pdf'" class="file-icon" src="@/assets/credit-request/example-pdf.svg" alt="pdf">
                  <img v-else-if="item.type === 'image/png'" class="file-icon" src="@/assets/credit-request/example-png.svg" alt="png">
                  <img v-else-if="item.type === 'application/vnd.ms-excel'" class="file-icon" src="@/assets/credit-request/example-xls.svg" alt="xls">
                  <img v-else class="file-icon" src="@/assets/credit-request/blank.svg" alt="blank">

                  <div class="name-wrapper">
                    <p class="name m-body-sb">{{ item.fileName}}</p>
                    <div v-if="item.loading" class="loading"></div>
                    <div v-if="item.msg" class="m-body-m" :class="item.error ? 'error-msg' : 'complete'">{{ item.msg }}</div>
                  </div>

                  <span class="clear" v-on:click="deleteDocument(item.fileId, item.fileName, 'declaration')">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 8L16 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M16 8L8 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </span>
                </div>
              </div>

              <div class="custom-file-upload">
                <label class="upload-btn main-btn second-color medium-btn" for="declaration">
                  Завантажити документ
                </label>
                <input type="file" id="declaration" ref="declaration" class="custom-file-input" @change="previewFiles($event.target,'declaration'); validateDocumentsError('declaration')" multiple>

                <span v-on:click="declaration = true" class="example m-body-sb">Приклад</span>
              </div>
            </div>

            <div class="item account-statement">
              <span v-if="accountStatementFilesError" class="error m-footnote-m">Завантажте мінімум один документ</span>
              <h3 v-if="type === 'flp'" class="title m-body-b">Виписка за рахунками ФОП свого банку з детальним розшифруванням рухів коштів за останні 12 міс.</h3>
              <h3 v-if="type === 'jur'" class="title m-body-b">Виписка за рахунками юридичної особи свого банку з детальним розшифруванням рухів коштів за останні 12 міс.</h3>
              <h4 class="subtitle m-body-m">Повинні бути відображені всі надходження та платежі з інформацією про контрагентів</h4>

              <div class="files">
                <div class="file-item" v-for="(item) in accountStatementFiles" :key="item.fileName">
                  <img v-if="item.type === 'application/msword'" class="file-icon" src="@/assets/credit-request/example-doc.svg" alt="doc">
                  <img v-else-if="item.type === 'image/jpeg'" class="file-icon" src="@/assets/credit-request/example-jpg.svg" alt="jpg">
                  <img v-else-if="item.type === 'application/pdf'" class="file-icon" src="@/assets/credit-request/example-pdf.svg" alt="pdf">
                  <img v-else-if="item.type === 'image/png'" class="file-icon" src="@/assets/credit-request/example-png.svg" alt="png">
                  <img v-else-if="item.type === 'application/vnd.ms-excel'" class="file-icon" src="@/assets/credit-request/example-xls.svg" alt="xls">
                  <img v-else class="file-icon" src="@/assets/credit-request/blank.svg" alt="blank">

                  <div class="name-wrapper">
                    <p class="name m-body-sb">{{ item.fileName}}</p>
                    <div v-if="item.loading" class="loading"></div>
                    <div v-if="item.msg" class="m-body-m" :class="item.error ? 'error-msg' : 'complete'">{{ item.msg }}</div>
                  </div>

                  <span class="clear" v-on:click="deleteDocument(item.fileId, item.fileName, 'accountStatement')">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 8L16 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M16 8L8 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </span>
                </div>
              </div>

              <div class="custom-file-upload">
                <label class="upload-btn main-btn second-color medium-btn" for="accountStatement">
                  Завантажити документ
                </label>
                <input type="file" id="accountStatement" ref="accountStatement" class="custom-file-input" @change="previewFiles($event.target, 'accountStatement'); validateDocumentsError('accountStatement')" multiple>

                <span v-on:click="accountStatement = true" class="example m-body-sb">Приклад</span>
              </div>
            </div>

            <div class="item business-photo">
              <span v-if="businessPhotoFilesError" class="error m-footnote-m">Завантажте щонайменше 3 фото</span>
              <h3 class="title m-body-b">Фото бізнесу (місце розташування торгової точки, асортимент товару, офіс і т.д.)</h3>
              <h4 class="subtitle m-body-m">Щонайменше 3 фотографій під різними ракурсами фактичного місця ведення бізнесу</h4>

              <div class="files">
                <div class="file-item" v-for="(item) in businessPhotoFiles" :key="item.fileName">
                  <img v-if="item.type === 'application/msword'" class="file-icon" src="@/assets/credit-request/example-doc.svg" alt="doc">
                  <img v-else-if="item.type === 'image/jpeg'" class="file-icon" src="@/assets/credit-request/example-jpg.svg" alt="jpg">
                  <img v-else-if="item.type === 'application/pdf'" class="file-icon" src="@/assets/credit-request/example-pdf.svg" alt="pdf">
                  <img v-else-if="item.type === 'image/png'" class="file-icon" src="@/assets/credit-request/example-png.svg" alt="png">
                  <img v-else-if="item.type === 'application/vnd.ms-excel'" class="file-icon" src="@/assets/credit-request/example-xls.svg" alt="xls">
                  <img v-else class="file-icon" src="@/assets/credit-request/blank.svg" alt="blank">

                  <div class="name-wrapper">
                    <p class="name m-body-sb">{{ item.fileName }}</p>
                    <div v-if="item.loading" class="loading"></div>
                    <div v-if="item.msg" class="m-body-m" :class="item.error ? 'error-msg' : 'complete'">{{ item.msg }}</div>
                  </div>

                  <span class="clear" v-on:click="deleteDocument(item.fileId, item.fileName, 'businessPhoto')">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 8L16 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M16 8L8 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </span>
                </div>
              </div>

              <div class="custom-file-upload">
                <label class="upload-btn main-btn second-color medium-btn" for="businessPhoto">
                  Завантажити документ
                </label>
                <input type="file" id="businessPhoto" ref="businessPhoto" class="custom-file-input" @change="previewFiles($event.target, 'businessPhoto'); validateDocumentsError('businessPhoto')" multiple>

                <span v-on:click="businessPhoto = true" class="example m-body-sb">Приклад</span>
              </div>
            </div>

            <div class="item business-photo osv-photo">
              <span v-if="osvFilesError" class="error m-footnote-m">Завантажте мінімум один документ</span>
              <h3 class="title m-body-b">ОСВ по рахунках 26,36,63,70 за останні 12 міс.</h3>

              <h4 v-if="type !== 'jur'" class="subtitle m-body-m">За наявності, повинні бути в форматі .xls</h4>
              <h4 v-if="type === 'jur'" class="subtitle m-body-m">Повинні бути в форматі .xls</h4>

              <div class="files">
                <div class="file-item" v-for="(item) in osvFiles" :key="item.fileName">
                  <img v-if="item.type === 'application/msword'" class="file-icon" src="@/assets/credit-request/example-doc.svg" alt="doc">
                  <img v-else-if="item.type === 'image/jpeg'" class="file-icon" src="@/assets/credit-request/example-jpg.svg" alt="jpg">
                  <img v-else-if="item.type === 'application/pdf'" class="file-icon" src="@/assets/credit-request/example-pdf.svg" alt="pdf">
                  <img v-else-if="item.type === 'image/png'" class="file-icon" src="@/assets/credit-request/example-png.svg" alt="png">
                  <img v-else-if="item.type === 'application/vnd.ms-excel'" class="file-icon" src="@/assets/credit-request/example-xls.svg" alt="xls">
                  <img v-else class="file-icon" src="@/assets/credit-request/blank.svg" alt="blank">

                  <div class="name-wrapper">
                    <p class="name m-body-sb">{{ item.fileName }}</p>
                    <div v-if="item.loading" class="loading"></div>
                    <div v-if="item.msg" class="m-body-m" :class="item.error ? 'error-msg' : 'complete'">{{ item.msg }}</div>
                  </div>

                  <span class="clear" v-on:click="deleteDocument(item.fileId, item.fileName, 'osvPhoto')">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 8L16 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      <path d="M16 8L8 16" stroke="#B4B9BE" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </span>
                </div>
              </div>

              <div class="custom-file-upload">
                <label class="upload-btn main-btn second-color medium-btn" for="osvPhoto">
                  Завантажити документ
                </label>
                <input
                  type="file"
                  id="osvPhoto"
                  ref="osvPhoto"
                  class="custom-file-input"
                  @change="previewFiles($event.target, 'osv'); validateDocumentsError('osvPhoto')"
                  multiple
                >

                <!-- TODO: example -->
                <span v-on:click="osvExample = true" class="example m-body-sb">Приклад</span>
              </div>
            </div>

          </div>

          <div class="agreement">
            <div class="check-agreement">
              <div class="default-checkbox">
                <input type="checkbox" id="check-agreement" name="check" checked disabled/>
                <label for="check-agreement"></label>
              </div>

              <p class="text m-body-m">
                Надаю
                <span v-on:click="agreementPopUp = true" class="resolution-popup">Дозвіл</span>
                на обробку моїх персональних даних та перевірки кредитної історії підприємства
              </p>
            </div>
          </div>
        </div>

        <div  v-if="currentStep.name === 'FinalStep'" class="form final-step">
          <h2 class="fn-title-1">{{finalText.title}}</h2>

          <p class="result-msg">{{finalText.text}}</p>

          <button class="second-btn second-color large-btn" v-on:click="$router.push('/')">
            Переглянути інші продукти
          </button>
        </div>

        <div class="buttons">
          <button
            v-if="currentStep.name !== 'FinalStep'"
            class="main-btn second-color large-btn next-btn"
            :disabled="disableSubmitButton"
            v-on:click="sendData(1)"
          >
            {{ currentStep.name === 'UploadDocument' ? 'Відправити анкету на обробку' : 'Продовжити' }}
          </button>
          <p v-if="errorSendData" class="error">Помилка під час відправки даних</p>
        </div>
      </section>
    </div>

    <PopUp v-if="agreementPopUp" :width="'600px'" :height="'auto'" :max-height="'80vh'" @close='close'>
      <p>
        Банк гарантує (згідно ст. 60, 61, 62 Закону України про банки і банківську діяльність М22121-ЇЇ від 07.12.00),
        що вся інформація, надана позичальником, буде використана суворо конфіденційно і тільки для прийняття рішення
        щодо цієї заявки на кредитний продукт. Уповноважені представники Позичальника погодились, що їх персональні дані
        та підприємства, які стали відомі АТ «Банк Альянс» (далі також - «Банк») на обробку їх персональних даних у
        картотеках та/або за допомогою інформаційно-телекомунікаційної системи бази персональних даних клієнтів Банку,
        та передачу даних третім особам з метою підтвердження повноважень суб'єкта на укладання, зміну та розірвання
        договорів, забезпечення реалізації адміністративно-правових та податкових відносин, відносин у сфері
        бухгалтерського обліку та статистики, а також для забезпечення реалізації інших передбачених законодавством
        відносин. Відправляючи цю Заявку, Позичальник надає АТ «Банк Альянс» згоду на доступ до своєї кредитної історії,
        збір, зберігання, використання та передачу (поширення) інформації, яка складає його кредитну історію, в будь-яке
        бюро кредитних історій (далі - «Бюро»), у тому числі: ТОВ «Українське бюро кредитних історій» (адреса: 01001, м.
        Київ, вул. Грушевського, 1-Д), ПАТ «Перше всеукраїнське бюро кредитних історій» (адреса: 02002, м. Київ, вул.
        Євгена Сверстюка, 11), ПАТ «Міжнародне бюро кредитних історій» (адреса: 03062, м. Київ, пр. Перемоги, 65, оф.
        306), для подальшого оброблення, використання та поширення такої інформації відповідно до чинного законодавства
        України. Кредитна історія передається в Бюро, зберігається та поширюється у формі та шляхами, які самостійно
        погоджуються Банком та Бюро. Позичальник підтверджує, що зазначена в цій Заявці згода надається ним з
        використанням термінів та понять, які передбачені Законом України «Про організацію формування та обігу кредитних
        історій» та з усвідомленням ним змісту вказаних термінів та понять. Позичальник згоден, що його кредитна
        історія, передана в згаданий вище спосіб, буде доступною через Бюро іншим особам.
      </p>
    </PopUp>
    <PopUp v-if="accountStatement" :width="'auto'" :height="'auto'" :max-height="'80vh'" @close='close'>
      <img class="example" style="max-width: 100%" src="@/assets/credit-request/example-doc/выписка.png" alt="icon">
    </PopUp>
    <PopUp v-if="businessPhoto" :width="'auto'" :height="'auto'" :max-height="'80vh'" @close='close'>
      <img class="example" style="max-width: 100%" src="@/assets/credit-request/example-doc/business-photo.jpg" alt="icon">
    </PopUp>
    <PopUp v-if="declaration && type === 'flp'" :width="'auto'" :height="'auto'" :max-height="'80vh'" @close='close'>
      <img class="example" style="max-width: 100%" src="@/assets/credit-request/example-doc/declaration.png" alt="icon">
    </PopUp>
    <PopUp v-if="osvExample" :width="'auto'" :height="'auto'" :max-height="'80vh'" @close='close'>
      <img class="example" style="max-width: 100%" src="@/assets/credit-request/example-doc/osv-example.jpg" alt="icon">
    </PopUp>
    <PopUp v-if="declaration && type === 'jur'" :width="'auto'" :height="'auto'" :max-height="'80vh'" @close='close'>
      <div style="display:flex; flex-direction: column; align-items: center; justify-content: center">
        <img width="600" style="max-width: 100%" class="example" src="@/assets/credit-request/example-doc/fin-balance1.jpg" alt="icon">
        <img width="600" style="max-width: 100%" class="example" src="@/assets/credit-request/example-doc/fin-balance2.jpg" alt="icon">
      </div>
    </PopUp>
  </div>
</template>

<script>
import * as Sentry from '@sentry/browser'

import { HTTP } from '@/httpСommon.js'
import DefaultInput from '@/components/Ui-new/DefaultInput.vue'
import DefaultTextArea from '@/components/Ui-new/DefaultTextArea.vue'
import DefaultRadio from '@/components/Ui-new/DefaultRadio.vue'
import PopUp from '@/components/Ui-new/PopUp.vue'
import AutocompleteSelect from '@/components/Ui-new/AutocompleteSelect.vue'
import NotFound from '@/components/404Page/notFound'

export default {
  name: 'CreditRequest',
  components: {
    NotFound,
    DefaultInput,
    DefaultTextArea,
    DefaultRadio,
    PopUp,
    AutocompleteSelect
  },
  data () {
    return {
      type: 'fiz',
      statusId: null,
      badRequest: false,
      loading: true,
      showMobileMenu: true,
      errorSendData: false,
      salesChannelsError: false,
      declarationFilesError: false,
      accountStatementFilesError: false,
      businessPhotoFilesError: false,
      osvFilesError: false,
      agreementPopUp: false,
      accountStatement: false,
      businessPhoto: false,
      osvExample: false,
      declaration: false,
      userDocuments: [],
      duplicateCount: 0,
      validation: false,
      directoryKveds: null,
      errorCode: 404,
      founderApprove: false,
      requestData: {
        name: 'Немає даних',
        productCode: null,
        code: 'Немає даних',
        businessDescription: 'Немає даних',
        creditType: 'Немає даних',
        creditSum: 'Немає даних',
        creditTerm: 'Немає даних'
      },
      supplementRequest: {
        kved: ['Немає даних'],
        name: 'Немає даних',
        kvedDisable: false,
        nameDisable: false,
        address_legal: 'Немає даних'
      },
      AboutBusiness: {
        business_description: 'Немає даних',
        suppliers: 'Немає даних',
        buyers: 'Немає даних',
        purpose_loan: [
          {
            name: 'purpose_loan',
            value: 'Поповнення оборотних коштів',
            id: 'assets',
            checked: false,
            disabled: false
          },
          {
            name: 'purpose_loan',
            value: 'Придбання основних засобів',
            id: 'capital',
            checked: false,
            disabled: false
          },
          {
            name: 'purpose_loan',
            value: 'Рефінансування кредиту іншого банка',
            id: 'equipment',
            checked: false,
            disabled: false
          }
        ],
        checkedID: '',
        sales_channels: {
          offline_store: {
            is_selected: null,
            attr: ['']
          },
          online_store: {
            is_selected: null,
            attr: ['']
          },
          social_networks: {
            is_selected: null,
            attr: ['']
          },
          other: {
            is_selected: null,
            attr: ['']
          }
        }
      },
      leaders: {
        leader: {
          name: null,
          term: null,
          code: null
        },
        founders: [
          {
            name: '',
            code: '',
            property: ''
          }
        ]
      },
      finance: {
        checkFinancialReporting: '',
        financialReporting: [
          {
            name: 'financial_reporting',
            value: 'Щорічно',
            id: 'year',
            checked: true
          },
          {
            name: 'financial_reporting',
            value: 'Щоквартально',
            id: 'quarter',
            checked: false
          }
        ],
        kveds: [
          {
            kved: '',
            summ: ''
          }
        ]
      },
      permittedTypesDocuments: ['msi', 'exe', 'deb', 'zip', 'rar', 'mp4', 'mp3', 'amr', 'm4r', 'm4a', 'mp2', 'ogg', 'wav'],
      count: 0,
      steps: [
        {
          stepNumber: 0,
          title: 'Доповніть заявку',
          name: 'SupplementRequest'
        },
        {
          stepNumber: 1,
          title: 'Розкажіть про свій бізнес',
          name: 'AboutBusiness'
        },
        {
          stepNumber: 2,
          title: 'Керівники',
          name: 'Leaders'
        },
        {
          stepNumber: 3,
          title: 'Про фінанси',
          name: 'Finance'
        },
        {
          stepNumber: 4,
          title: 'Додайте документи',
          name: 'UploadDocument'
        },
        {
          stepNumber: 5,
          title: 'Дякуємо',
          name: 'FinalStep'
        }
      ]
    }
  },
  computed: {
    finalText: function () {
      const reviewed = [3, 10, 11, 12, 16, 26, 30]
      const final = [31]
      let message = {
        title: 'Заявка успішно відправлена',
        text: 'Ми зараз активно працюємо над Вашою заявкою. Найближчим часом повідомимо Вам про результат розгляду.'
      }
      if (reviewed.indexOf(this.statusId) !== -1) {
        message = {
          title: 'Заявка розглянута банком. Дякуємо за звернення.',
          text: ''
        }
        return message
      } else if (final.indexOf(this.statusId) !== -1) {
        message = {
          title: 'Заявка видалена за строком.',
          text: ''
        }
        return message
      } else {
        return message
      }
    },
    kvedOptions: function () {
      const options = []
      for (const kved in this.directoryKveds) {
        options.push({ name: kved, optionId: kved })
      }
      return options
    },
    fileTypeId: function () {
      return {
        declaration: this.type === 'flp' ? 9 : 16,
        accountStatement: 21,
        businessPhoto: 8,
        osv: 43
      }
    },
    declarationFiles: function () {
      return this.userDocuments.filter(i => i.fileType === 'declaration')
    },
    accountStatementFiles: function () {
      return this.userDocuments.filter(i => i.fileType === 'accountStatement')
    },
    businessPhotoFiles: function () {
      return this.userDocuments.filter(i => i.fileType === 'businessPhoto')
    },
    osvFiles: function () {
      return this.userDocuments.filter(i => i.fileType === 'osv')
    },
    priorityFlpPerson: function () {
      if (this.supplementRequest.nameDisable && this.supplementRequest.kvedDisable && this.supplementRequest.address_legalDisable) {
        return [1, 4, 5]
      }
      return [0, 1, 4, 5]
    },
    priorityJurPerson: function () {
      if (this.supplementRequest.nameDisable && this.supplementRequest.kvedDisable && this.supplementRequest.address_legalDisable) {
        return [1, 2, 3, 4, 5]
      }
      return [0, 1, 2, 3, 4, 5]
    },
    currentPriority: function () {
      if (this.type === 'flp') {
        return this.priorityFlpPerson
      } else if (this.type === 'jur') {
        return this.priorityJurPerson
      } else {
        return this.priorityFlpPerson
      }
    },
    currentStep: function () {
      return this.steps[this.currentPriority[this.count]]
    },
    ref: function () {
      const pathUrl = window.location.pathname.split('/')
      return pathUrl[pathUrl.length - 1]
    },
    disableBackBtn: function () {
      if (this.type === 'flp' && this.priorityFlpPerson[0] === this.currentStep.stepNumber) {
        return true
      } else if (this.type === 'jur' && this.priorityJurPerson[0] === this.currentStep.stepNumber) {
        return true
      } else {
        return false
      }
    },
    disableSubmitButton: function () {
      console.log(this.type === 'jur', this.currentStep.name === 'Leaders', !this.founderApprove)
      return (this.type === 'jur' && this.currentStep.name === 'Leaders' && !this.founderApprove)
    }
  },
  methods: {
    customValidations: function () {
      if (this.currentStep.name === 'AboutBusiness' && this.validateSalesChannels()) {
        return false
      } else if (this.currentStep.name === 'UploadDocument' && this.validateDocumentsError('all')) {
        return false
      } else {
        return true
      }
    },
    validateDocumentsError: function (target) {
      if (target === 'all') {
        this.declarationFilesError = true
        this.accountStatementFilesError = true
        this.businessPhotoFilesError = true
        this.osvFilesError = true
      }

      if (target === 'declarationFiles') {
        this.declarationFilesError = true
      }
      if (target === 'accountStatement') {
        this.accountStatementFilesError = true
      }
      if (target === 'businessPhoto') {
        this.businessPhotoFilesError = true
      }
      if (target === 'osvFiles') {
        this.osvFilesError = true
      }

      this.declarationFilesError = !this.declarationFiles.filter(file => !file.error).length
      this.accountStatementFilesError = !this.accountStatementFiles.filter(file => !file.error).length
      this.businessPhotoFilesError = this.businessPhotoFiles.filter(file => !file.error).length < 3

      this.osvFilesError = this.type === 'jur'
        ? this.osvFiles.filter(file => !file.error).length < 1
        : false

      return this.declarationFilesError || this.accountStatementFilesError || this.businessPhotoFilesError || this.osvFilesError
    },
    validateSalesChannels: function () {
      let salesChannels = true
      for (const key in this.AboutBusiness.sales_channels) {
        if (this.AboutBusiness.sales_channels[key].is_selected) {
          salesChannels = false
        }
      }
      this.salesChannelsError = salesChannels
      return salesChannels
    },
    clearFields: function () {
      for (const key in this.AboutBusiness.sales_channels) {
        if (!this.AboutBusiness.sales_channels[key].is_selected) {
          this.AboutBusiness.sales_channels[key].attr = ['']
        }
      }
    },
    currentCount (value) {
      this.$validator.validateAll().then((result) => {
        if (result && this.customValidations()) {
          this.count += value
        }
      })
    },
    addNewKved () {
      const item = {
        kved: '',
        summ: ''
      }
      this.finance.kveds.push(item)
    },
    addNewFounder () {
      const item = {
        name: '',
        code: '',
        property: ''
      }
      this.leaders.founders.push(item)
    },
    previewFiles (target, fileType) {
      let fileTypeId = null

      for (const property in this.fileTypeId) {
        if (property === fileType) {
          fileTypeId = this.fileTypeId[property]
        }
      }
      target.files.forEach((inputFile) => {
        if (inputFile.size > 25000000) {
          this.userDocuments.splice(this.userDocuments.length, 0,
            {
              fileType: fileType,
              fileName: inputFile.name,
              type: inputFile.type,
              loading: false,
              fileId: 'errorFile',
              msg: 'Перевищує допустимий розмір файлу',
              error: true
            })
        } else if (!this.allowDocument(inputFile)) {
          this.userDocuments.splice(this.userDocuments.length, 0,
            {
              fileType: fileType,
              fileName: inputFile.name,
              type: inputFile.type,
              loading: false,
              fileId: 'errorFile',
              msg: 'Невірний формат файлу',
              error: true
            })
        } else {
          let errorFile = false
          this.userDocuments.forEach((file) => {
            if (file.fileName === inputFile.name) {
              errorFile = true
            }
          })
          if (errorFile) {
            this.duplicateCount++
            this.userDocuments.splice(this.userDocuments.length, 0,
              {
                fileType: fileType,
                fileName: inputFile.name + `(${this.duplicateCount})`,
                type: inputFile.type,
                loading: false,
                fileId: 'errorFile',
                msg: 'Такий файл вже прикріплений до заявки',
                error: true
              })
          } else {
            this.userDocuments.splice(this.userDocuments.length, 0,
              {
                fileType: fileType,
                fileName: inputFile.name,
                type: inputFile.type,
                loading: true,
                fileId: null,
                msg: '',
                error: false
              })
            this.uploadDocument(inputFile, fileTypeId, fileType)
          }
        }
      })
    },
    uploadDocument (file, fileType, fileTypeName) {
      const formData = new FormData()
      formData.append('file', file)
      formData.append('type_id', fileType)
      formData.append('ref_journal', this.ref)
      HTTP
        .post('api/v1/questionnaire/file/upload', formData)
        .then(response => {
          this.userDocuments.forEach((target, index) => {
            if (target.fileType === fileTypeName) {
              if (target.fileName === file.name) {
                this.userDocuments[index].msg = 'Додано'
                this.userDocuments[index].loading = false
                this.userDocuments[index].fileId = response.data.data.document_id
              }
            }
          })

          this.$toastr('success', 'Файл додано.')
        })
        .catch(err => {
          this.userDocuments.forEach((target, index) => {
            if (target.fileType === fileTypeName) {
              if (target.fileName === file.name) {
                this.userDocuments[index].msg = err.data.error.message
                this.userDocuments[index].loading = false
                this.userDocuments[index].fileId = true
              }
            }
          })
          console.log(err)

          this.$toastr('error', `Помилка. Файл не додано. ${err.message}`)
        })
    },
    deleteDocument (fileId, fileName, inputRefName) {
      if (fileId === 'errorFile') {
        this.userDocuments = this.userDocuments.filter(i => i.fileName !== fileName)
      } else {
        const data = {
          ref_journal: this.ref,
          file_id: fileId
        }
        let fileIndex = null
        this.userDocuments.forEach((document, index) => {
          if (document.fileId === fileId) {
            fileIndex = index
          }
        })
        this.userDocuments[fileIndex].loading = true

        HTTP
          .delete('api/v1/questionnaire/file/delete', { data })
          .then(response => {
            this.userDocuments = this.userDocuments.filter(i => i.fileId !== fileId)
            this.$refs[inputRefName].value = null
            this.$toastr('success', 'Файл видалено.')
          })
          .catch(err => {
            console.log(err)
            this.userDocuments[fileIndex].loading = false

            this.$toastr('error', `Помилка. Файл не видалено. ${err.message}`)
          })
      }
    },
    allowDocument (document) {
      let validDoc = true
      const typeDocument = document.name.split('.').pop()
      this.permittedTypesDocuments.forEach((file) => {
        if (file === typeDocument) {
          validDoc = false
        }
      })
      return validDoc
    },
    close (data) {
      this.agreementPopUp = data.close
      this.declaration = data.close
      this.businessPhoto = data.close
      this.accountStatement = data.close
      this.osvExample = data.close
    },
    sendRequest: function (data, count) {
      this.$validator.validateAll().then((result) => {
        if (result && this.customValidations()) {
          this.loading = true
          HTTP.post(`api/v1/questionnaire/${this.ref}`, data, { headers: { 'content-type': 'application/json', Accept: 'application/json' } })
            .then(response => {
              this.loading = false
              this.currentCount(count)
              this.errorSendData = false
              this.$scrollTo({ el: '#toHead', duration: 200 })
              if (this.type === 'jur') {
                this.finance.kveds = response.data.data['2000_f1'][0]
                  ? response.data.data['2000_f1']
                  : [{
                    kved: response.data.data.kveds
                      ? response.data.data.kveds[0]
                      : '',
                    summ: ''
                  }]
              }
            })
            .catch(err => {
              console.log(err)
              this.loading = false
              this.errorSendData = true
            })
        }
      })
    },
    sendData: function (count) {
      const options = {
        headers: {
          'content-type': 'application/json',
          Accept: 'application/json'
        }
      }

      let data = null
      if (this.currentStep.name === 'SupplementRequest') {
        data = {
          name: this.supplementRequest.name,
          kveds: this.supplementRequest.kved,
          address_legal: this.supplementRequest.address_legal
        }

        this.sendRequest(data, count)
      } else if (this.currentStep.name === 'AboutBusiness') {
        data = {
          business_description: this.AboutBusiness.business_description,
          suppliers: this.AboutBusiness.suppliers,
          buyers: this.AboutBusiness.buyers,
          purpose_loan: this.AboutBusiness.checkedID,
          sales_channels: {
            offline_store: this.AboutBusiness.sales_channels.offline_store.attr[0] ? this.AboutBusiness.sales_channels.offline_store.attr : null,
            online_store: this.AboutBusiness.sales_channels.online_store.attr[0] ? this.AboutBusiness.sales_channels.online_store.attr : null,
            social_networks: this.AboutBusiness.sales_channels.social_networks.attr[0] ? this.AboutBusiness.sales_channels.social_networks.attr : null,
            other: this.AboutBusiness.sales_channels.other.attr[0] ? this.AboutBusiness.sales_channels.other.attr : null
          }
        }
        this.sendRequest(data, count)
      } else if (this.currentStep.name === 'Leaders') {
        data = {
          leaders: [
            {
              code: this.leaders.leader.code,
              name: this.leaders.leader.name,
              term: this.leaders.leader.term
            }
          ],
          founders: this.leaders.founders
        }
        this.sendRequest(data, count)
      } else if (this.currentStep.name === 'Finance') {
        data = {
          financial_reporting: this.finance.checkFinancialReporting,
          '2000_f1': this.finance.kveds
        }
        this.$validator.validateAll().then((result) => {
          if (result && this.customValidations()) {
            HTTP.get(`api/v1/questionnaire/${this.ref}/files`, options)
          }
        })
        this.sendRequest(data, count)
      } else if (this.currentStep.name === 'UploadDocument') {
        if (count === 1) {
          data = {
            journal_ref: this.ref,
            status_id: this.statusId === 9 ? 7 : 2,
            comment: null
          }
          this.$validator.validateAll().then((result) => {
            if (result && this.customValidations()) {
              this.loading = true
              HTTP.post('api/v1/questionnaire/status', data, options)
                .then(response => {
                  this.loading = false
                  this.$scrollTo({ el: '#toHead', duration: 200 })
                  this.currentCount(count)
                  this.errorSendData = false
                })
                .catch(err => {
                  console.log(err)
                  this.loading = false
                  this.errorSendData = true
                })
            }
          })
        } else {
          this.currentCount(count)
        }
      }
    },
    getDocuments (response) {
      response.data.data.documents.forEach((document) => {
        let type = ''
        if (document.type.id === 9 || document.type.id === 16) {
          type = 'declaration'
        }
        if (document.type.id === 8) {
          type = 'businessPhoto'
        }
        if (document.type.id === 21) {
          type = 'accountStatement'
        }
        if (document.type.id === 43) {
          type = 'osv'
        }

        this.userDocuments.splice(this.userDocuments.length, 0, {
          fileType: type,
          fileName: document.name,
          type: document.mime_type,
          loading: false,
          fileId: document.id,
          msg: 'Додано',
          error: false
        })
      })
    },
    toggleFounderApprove () {
      this.founderApprove = !this.founderApprove
    }
  },
  mounted () {
    this.$scrollTo({ el: '#toHead', duration: 200 })
    HTTP.get('/api/v1/dics/kved', {
      headers: {
        'content-type': 'application/json',
        Accept: 'application/json'
      }
    }).then(response => { this.directoryKveds = response.data.data })
    HTTP.get(`api/v1/questionnaire/${this.ref}/files`, {
      headers: {
        'content-type': 'application/json',
        Accept: 'application/json'
      }
    }).then(response => { this.getDocuments(response) })

    this.loading = true
    const pathUrl = window.location.pathname.split('/')
    const ref = pathUrl[pathUrl.length - 1]
    HTTP
      .get(`api/v1/questionnaire/${ref}`)
      .then(response => {
        this.loading = false
        this.badRequest = false

        const {
          status,
          type,
          author,
          code,
          business_description: businessDescription,
          product,
          kveds,
          name,
          address_legal: addressLegal,
          suppliers,
          buyers,
          purpose_loan: purposeLoan,
          sales_channels: salesChannels,
          leaders,
          founders,
          financial_reporting: financialReporting,
          '2000_f1': f1
        } = response?.data?.data ?? {}

        const [leader] = leaders || []

        this.statusId = status.id
        this.type = type
        this.founderApprove = false

        this.requestData = {
          ...this.requestData,
          name: author.name,
          code: code,
          businessDescription: businessDescription,
          creditType: product?.name,
          productCode: product?.code,
          creditSum: product?.sum,
          creditTerm: product?.term
        }

        this.supplementRequest = {
          ...this.supplementRequest,
          kved: kveds ?? [''],
          name: name ?? '',
          address_legal: addressLegal || '',
          kvedDisable: !!kveds,
          nameDisable: !!name,
          address_legalDisable: !!addressLegal
        }

        this.AboutBusiness = {
          ...this.AboutBusiness,
          business_description: businessDescription,
          suppliers: suppliers,
          buyers: buyers
        }

        if (this.requestData.productCode === 'VKL') {
          this.AboutBusiness.purpose_loan[0].checked = true
          this.AboutBusiness.purpose_loan[1].disabled = true
          this.AboutBusiness.purpose_loan[2].disabled = true
        } else {
          this.AboutBusiness.purpose_loan[0].checked = purposeLoan?.assets?.is_selected
          this.AboutBusiness.purpose_loan[1].checked = purposeLoan?.capital?.is_selected
          this.AboutBusiness.purpose_loan[2].checked = purposeLoan?.equipment?.is_selected
        }

        this.AboutBusiness.sales_channels.offline_store.is_selected = salesChannels?.offline_store
          ? salesChannels?.offline_store?.is_selected
          : false
        this.AboutBusiness.sales_channels.online_store.is_selected = salesChannels?.online_store
          ? salesChannels?.online_store?.is_selected
          : false
        this.AboutBusiness.sales_channels.social_networks.is_selected = salesChannels?.social_networks
          ? salesChannels?.social_networks?.is_selected
          : false
        this.AboutBusiness.sales_channels.other.is_selected = salesChannels?.other
          ? salesChannels?.other?.is_selected
          : false
        this.AboutBusiness.sales_channels.offline_store.attr = salesChannels?.offline_store
          ? salesChannels?.offline_store?.attr
          : ['']
        this.AboutBusiness.sales_channels.online_store.attr = salesChannels?.online_store
          ? salesChannels?.online_store?.attr
          : ['']
        this.AboutBusiness.sales_channels.social_networks.attr = salesChannels?.social_networks
          ? salesChannels?.social_networks?.attr
          : ['']
        this.AboutBusiness.sales_channels.other.attr = salesChannels?.other
          ? salesChannels?.other?.attr
          : ['']

        if (this.type === 'jur') {
          this.leaders.leader = {
            name: leader?.name ?? '',
            code: leader?.code ?? '',
            term: leader?.term ?? ''
          }

          this.leaders.founders = founders && founders.length > 0
            ? founders
            : [{ name: '', code: '', property: '' }]

          this.finance.financialReporting.forEach((item, index) => {
            this.finance.financialReporting[index].checked = item.id === financialReporting
          })

          this.finance.kveds = f1?.[0]
            ? f1
            : [{
              kved: kveds ? kveds[0] : '',
              summ: ''
            }]

          if (status.id === 9) {
            this.count = 3
          } else if (status.id !== 1 && status.id !== 40) {
            this.count = 4
          }
        }

        if (this.type === 'flp') {
          if (status.id === 9) {
            this.count = 1
          } else if (status.id !== 1 && status.id !== 40) {
            this.count = 2
          }
        }
      })
      .catch(err => {
        if (err?.response?.status) {
          this.errorCode = err?.response?.status
        } else {
          console.error(err)
          Sentry.captureException(err)
        }
        this.loading = false
        this.badRequest = true
      })
  }
}
</script>

<style lang="less" scoped>
.loader {
  position: fixed;
  margin: auto;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.credit-request {
  display: flex;
  width: 100%;

  .info-column {
    position: fixed;
    z-index: 50;
    top: 0;
    bottom: 0;
    display: flex;
    flex-direction: column;
    padding: 0 40px;
    width: 376px;
    border-right: 1px solid var(--grey-230);
    background: var(--white);
    transition: 0.4s;

    @media (max-width: 1024px) {
      width: 100%;
      right: 0;
      left: 0;
      box-sizing: border-box;
      padding: 0;
    }

    .header {
      margin: 0 0 40px 0;

      .icon {
        display: none;
      }

      .title {
        margin: 56px 0 26px 0;
      }

      @media (max-width: 1024px) {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin: 0 0 20px 0;
        padding: 0 16px;
        min-height: 84px;
        cursor: pointer;

        .icon {
          display: block;
          transform: rotate(0);
        }

        .title {
          margin: 0;
        }
      }
    }

    .target-info {
      list-style: none;
      padding: 0;
      margin: 0;

      @media (max-width: 1024px) {
        padding: 0 16px;
        overflow: scroll;
      }

      .item {
        border-bottom: 1px solid var(--grey-240);

        .title {
          display: block;
          margin: 0 0 4px 0;
          color: var(--grey-140);
        }

        .data {
          margin: 0 0 8px 0;
          color: var(--black);
        }
      }

      .item + .item {
        margin: 20px 0 0 0;
      }
    }
  }
  .info-column.showMobileMenu {
    @media (max-width: 1024px) {
      top: calc(100% - 84px);

      .header {
        background: var(--grey-250);
        border-top: 1px solid var(--grey-240);

        .icon {
          display: block;
          transform: rotate(180deg);
        }
      }
    }
  }

  .main-column {
    display: flex;
    flex-direction: column;
    width: 76%;
    margin: 0 0 400px 465px;

    @media (max-width: 1024px) {
      margin: 0 0 50% 0;
      width: 100%;
    }

    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 56px 56px 56px;
      min-width: 460px;
      border-bottom: 1px solid var(--grey-230);

      @media (max-width: 1024px) {
        flex-wrap: wrap;
        flex-direction: column-reverse;
        align-items: flex-start;
        margin: 0 16px 40px 0;
        min-width: auto;
        border-bottom: none;
      }

      .title {
        margin: 56px 0 26px 0;

        @media (max-width: 1024px) {
          margin: 0 0 0 16px;
          width: 100%;
        }
      }

      .steps {
        display: flex;
        margin: 56px 0 26px 0;

        @media (max-width: 1024px) {
          justify-content: space-between;
          margin: 18px 0 50px 0;
          width: 100%;
        }

        .arrow-wrapper {
          display: flex;
        }

        .arrow {
          display: flex;
          align-items: center;
          justify-content: center;
          height: 28px;
          width: 25px;
          cursor: pointer;

          svg {
            width: 6px;
            height: 12px;
          }

          @media (max-width: 1024px) {
            height: 34px;
            width: 34px;
          }
        }

        .arrow.disable {
          pointer-events: none;

          path {
            stroke: var(--grey-140);
          }
        }

        .step-number {
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 0 0 20px;
        }

        .arrow + .arrow {
          margin: 0 0 0 7px;
        }
      }
    }

    .form {
      margin: 0 56px 56px 56px;
      width: 460px;

      @media (max-width: 1024px) {
        width: auto;
        margin: 0 2% 56px 2%;
      }

      .input + .input {
        margin: 12px 0 0 0;
      }

      button.add-items {
        margin: 12px 0 40px 0;
        color: var(--grey-140);

        .icon-plus {
          path {
            stroke: var(--grey-140);
          }
        }

        &:hover {
          color: var(--main-base);

          .icon-plus {
            path {
              stroke: var(--main-base);
            }
          }
        }

        &:focus {
          color: var(--main-base);

          .icon-plus {
            path {
              stroke: var(--main-base);
            }
          }
        }
      }
    }

    .about-business {
      .target-credit {
        margin: 60px 0 56px 0;

        .title {
          margin: 0 0 20px 0;
        }

        .error {
          display: inline-block;
          margin: 0 0 8px 0;
        }
      }

      .select-type {
        display: flex;
        flex-direction: column;
      }

      .sales-channel {
        margin: 56px 0 0 0;

        .title {
          margin: 0 0 20px 0;
        }

        .item {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          border-top: 1px solid var(--grey-240);

          .title {
            margin: 0;
            padding: 16px 0;
          }

          .toggle-wrapper {
            display: flex;
            flex-direction: column;
            width: 100%;

            .sales-items {
              .item  {
                position: relative;
                display: block;
                margin: 12px 0 0 0;

                .clear {
                  position: absolute;
                  cursor: pointer;
                  right: 8px;
                  top: 16px;
                }
              }
            }
          }
        }
      }
    }

    .upload-documents {
      .recommendation {
        position: relative;
        margin: 0 0 0 0;
        padding: 12px 12px 12px 48px;
        background: var(--grey-250);
        border-radius: var(--default-br);
        border: 1px solid var(--grey-240);
        box-sizing: border-box;

        .text {
          color: var(--grey-140);
        }

        .icon {
          position: absolute;
          left: 14px;
          top: 14px;
          width: 20px;
          height: 20px;
        }
      }

      .upload-items {
        .item {
          .title {
            margin: 56px 0 8px 0;
            color: var(--black);
          }

          .error {
            display: block;
            margin: 56px 0 0 0;
          }

          .error + .title {
            margin: 8px 0 0 0;
          }

          .subtitle {
            margin: 0 0 40px 0;
            color: var(--grey-140);
          }

          .files {
            display: flex;
            flex-direction: column;
            margin: 0 0 40px 0;

            .file-item {
              position: relative;
              display: flex;
              padding: 12px;
              border: 1px solid var(--grey-240);
              border-radius: var(--default-br);
              background: var(--white);

              .file-icon {
                margin: 0 12px 0 0;
              }

              .name-wrapper {
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin: 0 15px 0 0;
                width: 100%;

                .name + .loading {
                  margin: 10px 0 0 0;
                }

                .name + .complete {
                  margin: 0;
                }

                .state {
                  color: var(--green);
                }

                .name {
                  word-break: break-all;
                }
              }

              .clear {
                position: absolute;
                top: 8px;
                right: 8px;
                cursor: pointer;
              }

              .loading {
                position: relative;
                width: 100%;
                height: 4px;
                background: var(--second-40);
                border-radius: 50px;

                &:before {
                  content: '';
                  position: absolute;
                  left: 0;
                  right: auto;
                  width: 258px;
                  height: 4px;
                  background: var(--second-base);
                  border-radius: 50px;
                  animation: box-default 0.8s ease-in-out infinite;

                  @media (max-width: 1024px) {
                    width: 200px;
                    animation: box-1024 0.8s ease-in-out infinite;
                  }
                }

                @keyframes box-default {
                  0% { left: 0 }
                  50% { left: calc(100% - 258px) }
                }

                @keyframes box-1024 {
                  0% { left: 0 }
                  50% { left: calc(100% - 200px) }
                }
              }

              .complete {
                color: var(--green)
              }

              .error-msg {
                color: var(--red);
              }
            }

            .file-item + .file-item {
              margin: 8px 0 0 0;
            }
          }

          .custom-file-upload {
            margin: 0 0 56px 0;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            @media (max-width: 1024px) {
              flex-wrap: wrap;
            }

            input {
              display: none;
            }

            .upload-btn {
              display: flex;
              width: 226px;

              @media (max-width: 1024px) {
                margin: 0 0 12px 0;
                width: 100%;
              }
            }

            .example {
              display: flex;
              align-items: center;
              margin: 0 0 0 24px;
              width: 107px;
              height: 44px;
              color: var(--grey-180);
              cursor: pointer;

              @media (max-width: 1024px) {
                width: 100%;
                justify-content: center;
              }
            }
          }
        }

        .item + .item {
          border-top: 1px solid var(--grey-240);
        }
      }

      .agreement {
        padding: 20px 0 0 0;
        border-top: 1px solid var(--grey-230);

        .check-agreement {
          width: 460px;
          display: flex;

          .text {
            color: var(--grey-180);
          }

          .default-checkbox {
            margin: 0 12px 0 0;
          }
        }

        .resolution-popup {
          cursor: pointer;
          text-decoration: underline;
        }
      }
    }

    .final-step {
      .result-msg {
        margin: 16px 0 56px 0;
      }

      @media (max-width: 1024px) {
        flex-wrap: wrap;
      }
    }

    .leaders {
      .leaders-form {
        margin: 0 0 56px 0;
      }

      .founders {
        margin: 0 0 40px 0;

        .title {
          margin: 0 0 8px 0;
          color: var(--black);
        }

        .subtitle {
          color: var(--grey-140);
        }
      }

      .founders-form {
        margin: 0 0 56px 0;

        .inputs-wrapper {
          .founder-item + .founder-item {
            padding: 56px 0 0 0;
            margin: 56px 0 0 0;
            border-top: 1px solid var(--grey-240);
          }

          .founder-item {
            .input {
              position: relative;

              .clear {
                position: absolute;
                cursor: pointer;
                right: 8px;
                top: 16px;
              }
            }
          }
        }
      }

      .founderApprove {
        display: flex;
        align-items: center;
        gap: 16px;
      }
    }

    .finance {
      .select-period {
        margin: 20px 0 56px 0;
      }

      .qved {
        margin: 0 0 74px 0;

        .qved-2000-1 {
          .title {
            margin: 0 0 8px 0;
          }

          .subtitle {
            margin: 0 0 40px 0;
            color: var(--grey-140);
          }
        }

        .items-wrapper {
          display: flex;
          flex-direction: column;

          .item-row {
            display: flex;
            position: relative;

            .input {
              width: 100%;
            }

            .input + .input {
              margin: 0 0 0 8px;
            }

            .clear {
              position: absolute;
              cursor: pointer;
              right: 8px;
              top: 16px;
            }
          }

          .item-row + .item-row {
            margin: 12px 0 0 0;
          }
        }
      }
    }

    .buttons {
      margin: 0 0 0 56px;

      @media (max-width: 1024px) {
        margin: 0;

        .next-btn {
          width: 100%;
        }
      }
    }
  }
}
</style>
